var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagsDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.12012H21.758C22.5531 2.12029 23.3156 2.43608 23.878 2.99812L44 23.1201",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.258 8.12012H5C3.34315 8.12012 2 9.46326 2 11.1201V23.3761C1.99964 24.1719 2.31547 24.9352 2.878 25.4981L22.378 44.9981C22.9407 45.5611 23.704 45.8775 24.5 45.8775C25.296 45.8775 26.0593 45.5611 26.622 44.9981L38.878 32.7401C40.0491 31.5686 40.0491 29.6696 38.878 28.4981L19.378 9.00012C18.8159 8.43735 18.0534 8.12082 17.258 8.12012Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.3701C10.5858 16.3701 10.25 16.7059 10.25 17.1201C10.25 17.5343 10.5858 17.8701 11 17.8701C11.4142 17.8701 11.75 17.5343 11.75 17.1201C11.7505 16.921 11.6717 16.73 11.5309 16.5892C11.3902 16.4484 11.1991 16.3696 11 16.3701V16.3701",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsDouble);
export default __webpack_public_path__ + "static/media/tags-double.8f6d8ea10afbbcd11e303f459dccbba7.svg";
export { ForwardRef as ReactComponent };